
import { Component, Vue } from 'vue-property-decorator'

@Component({ name: 'MonitorRisk' })
export default class MonitorRisk extends Vue {}
